<div class="gl-page">
  <small class="jobprocess-note">(This list is only available in test enviroments)</small>
  <div class="gl-page__header">
    <h1 class="gl-page__title">Job(s)</h1>

    <div class="gl-page__header-actions">
      <yds-button variant="primary" (click)="navigateToCreate()">
        Job toevoegen
      </yds-button>
    </div>
  </div>

  <div class="gl-list-toolbar__top jobprocess-filters">
    <yds-dropdown
      label="Aantal"
      [items]="takeOptions"
      [value]="takeValue()"
      [allowClear]="false"
      size="sm"
      (valueChange)="onTakeChange($event)"
    />
    <yds-dropdown
      label="Status"
      placeholder="Alle statussen"
      [items]="statusOptions"
      [value]="statusValue()"
      size="sm"
      (valueChange)="onStatusChange($event)"
    />
  </div>

  @if (isLoading()) {
    <yds-card>
      <div class="gl-list-state">
        <yds-spinner [label]="'Jobs laden...'" />
      </div>
    </yds-card>
  } @else if (tableItems().length === 0) {
    <yds-empty-states [message]="'Er zijn nog geen jobs'" />
  } @else {
    <yds-card>
      <div class="gl-list-table">
        <yds-table
          [embedded]="true"
          [showPaginationFooter]="jobs().length > 0"
          [columns]="tableColumns"
          [items]="tableItems()"
          [zebra]="true"
          [dottedColumns]="true"
          [clickable]="true"
          (rowClick)="onTableRowClick($event)"
        >
          <ng-template ydsTableCell="notRestartable" let-item="item">
            @if (item.notRestartable) {
              <span class="vismaicon vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
            }
          </ng-template>

          <ng-template ydsTableCell="actions" let-item="item">
            <yds-split-button
              label="Bekijk details"
              [items]="splitButtonItemsForRow(item.status)"
              variant="default"
              size="sm"
              (mainClick)="viewItem(item.id, $event)"
              (itemClick)="handleActionClick(item.id, $event)"
            ></yds-split-button>
          </ng-template>

          @if (jobs().length > 0) {
            <yds-pagination
              pagination
              [(pageIndex)]="pageIndex"
              [pageSize]="pageSize"
              [totalItems]="jobs().length"
            />
          }
        </yds-table>
      </div>
    </yds-card>
  }
</div>
